import React from 'react'
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../../components/grid-container/GridContainer"
import { UiButtonPrimary, UiButtonIcon } from "../../../components/form/UiButton"
import AddToFavourites from "../../../../../styles/img/svg/AddToFavourites"
import { UiInput } from "../../../components/form/UiInput"
import UiAmountTile from "../../../components/common/UiAmountTile"

import {
    UiProductContent,
    UiProductContentMainTitle,
    UiProductContentSubTitle,
    UiProductContentSection,
    UiProductContentOverview,
    UiProductContentFeatures,
    UiProductContentDescription,
    UiProductTermsOfPurchase,
    UiPointBreakDownWr,
    UiPointBreakDownCol
} from "../../../components/common/UiProductElements"


export default function OrderContent(props) {

    return (
        <>
            <UiProductContent>
                <UiProductContentMainTitle title="Ultimate London Weekend" />
                <UiProductContentSubTitle subtitle="Lorem Epsum Product - 2,500 points" />
                <UiProductContentDescription description="Timperdiet gravida scelerisque odio nunc. Eget felis, odio bibendum quis eget sit lorem donec diam. Volutpat sed orci turpis sit dolor est a pretium eget. Vitae turpis orci vel tellus cursus lorem vestibulum quis eu. Ut commodo, eget lorem venenatis urna." />
                <hr/>
                 <UiProductContentOverview description="Timperdiet gravida scelerisque odio nunc. Eget felis, odio bibendum quis eget sit lorem donec diam. Volutpat sed orci turpis sit dolor est a pretium eget. Vitae turpis orci vel tellus cursus lorem vestibulum quis eu. Ut commodo, eget lorem venenatis urna. Pretium eget. Vitae turpis orci vel tellus cursus lorem vestibulum quis eu.">
                    <UiProductContentFeatures
                        wifi={true}
                        bathup={true}
                        breakfast={true}
                        kingbed={true}
                        size={true} />
                </UiProductContentOverview> 
                <UiProductTermsOfPurchase description="Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Ut enim ad minim veniam, quis nostrud exercitation ullamco."/>
            </UiProductContent>

        </>
    )
}

